/**
 * 顶栏/菜单待办提醒项配置。
 * 新增提醒场景三步接入：
 * 1. 后端 undo/list 返回对应计数键（独立容错）；
 * 2. 本数组追加一条配置；
 * 3. 对应列表页在数据刷新后派发 window CustomEvent（配置中的 refreshEvent）。
 *
 * matchHref 规则：与 m_menu.url 做包含匹配（layout._hrefMatches 含边界校验，
 * 匹配串后紧跟路径字符则不命中），
 * 取值必须确认不被其他菜单 url 包含
 * （反例：'areaAppeal' 会误匹配 areaAppealList / areaAppealTypeList，故取 'areaWorkbench'）。
 */
const TODO_ITEMS = [
  {
    key: 'repair',
    matchHref: 'repairPoolManage',
    jumpTo: '/pages/property/repairPoolManage',
    blinkLabelKey: 'layout.blinkRepair',
    todoTipKey: 'layout.repairTodoTip',
    todoLabelKey: 'layout.repairTodoLabel',
    refreshEvent: 'repair-pool-changed'
  },
  {
    key: 'areaAppeal',
    matchHref: 'areaWorkbench',
    jumpTo: '/pages/areaWorkbench',
    blinkLabelKey: 'layout.blinkAreaAppeal',
    todoTipKey: 'layout.areaAppealTodoTip',
    todoLabelKey: 'layout.areaAppealTodoLabel',
    refreshEvent: 'area-appeal-changed'
  },
  {
    key: 'complaintTodo',
    // 边界匹配（layout._hrefMatches）：投诉建议 url '/#/pages/complaint/complaint' 匹配，
    // 投诉类型 url '/#/pages/complaint/complaintType' 因匹配串后紧跟字母 T 不会误命中
    matchHref: 'pages/complaint/complaint',
    jumpTo: '/pages/complaint/complaint',
    blinkLabelKey: 'layout.blinkComplaint',
    todoTipKey: 'layout.complaintTodoTip',
    todoLabelKey: 'layout.complaintTodoLabel',
    refreshEvent: 'complaint-changed'
  },
  {
    key: 'onlinePropertyPay',
    // 'reportOnlinePropertyPay' 为报表页路径独有片段，无其他菜单 url 包含，不会误匹配
    matchHref: 'reportOnlinePropertyPay',
    jumpTo: '/pages/property/reportOnlinePropertyPay',
    blinkLabelKey: 'layout.blinkOnlinePropertyPay',
    todoTipKey: 'layout.onlinePropertyPayTodoTip',
    todoLabelKey: 'layout.onlinePropertyPayTodoLabel',
    refreshEvent: 'online-property-pay-changed'
  }
]

export default TODO_ITEMS
